// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Background */
.new-demo-page-container {
  min-height: 100vh;
  background-color: #240946;
  padding: 0;
  position: relative;
  overflow-x: hidden;
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
}

/* Core Container System */
.demo-content-container {
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}

@media (max-width: 991px) {
  .demo-content-container {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media (max-width: 767px) {
  .demo-content-container {
    padding-left: 16px;
    padding-right: 16px;
  }

  .tf-thumbnails {
    gap: 2px !important;
  }
}

/* Header */
.demo-header {
  background: #ffffff;
  border-radius: 50px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10), inset 0 0 0 1.5px #B9B9B9;
  width: 95%;
  height: 70px;
  max-width: 1400px;
  z-index: 1000;
  position: fixed;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 15px;
}

@media (min-width: 768px) {
  .demo-header {
    height: 80px;
    padding: 0 20px;
  }
}

@media (min-width: 992px) {
  .demo-header {
    height: 100px;
    padding: 0 40px;
  }
}

.demo-logo {
  height: 32px;
  object-fit: contain;
}

@media (min-width: 768px) {
  .demo-logo {
    height: 40px;
  }
}

@media (min-width: 992px) {
  .demo-logo {
    height: 60px;
  }
}

/* Try Glammify Button */
.new-demo-try-btn {
  padding: 0 16px;
  height: 36px;
  border-radius: 30px;
  background: linear-gradient(90deg, #6318C6 0%, #D89824 100%);
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  font-family: var(--font-codec-cold, sans-serif);
}

@media (min-width: 768px) {
  .new-demo-try-btn {
    padding: 3px 28px 0px 28px;
    height: 40px;
    font-size: 15px;
  }
}

@media (min-width: 992px) {
  .new-demo-try-btn {
    padding: 0 28px;
    height: 48px;
    font-size: 19px;
  }
}

.new-demo-try-btn:hover {
  opacity: 0.9;
}

/* Main Section Background */
.new-demo-main-section {
  background: linear-gradient(135deg,
      #59168B 0%,
      #8200DB 50%,
      #9810FA 100%);
  /* background: linear-gradient(90deg, #59168B 0%, #8200DB 50%, #9810FA 100%); */
  border-bottom-right-radius: 80px;
  padding-top: 110px;
  /* Space for fixed header */
  padding-bottom: 60px;
  color: white;
  position: relative;
  overflow: hidden;
}

@media (min-width: 768px) {
  .new-demo-main-section {
    border-bottom-right-radius: 238px;
    padding-top: 150px;
    padding-bottom: 40px;
  }
}

@media (min-width: 992px) {
  .new-demo-main-section {
    border-bottom-right-radius: 238px;
    padding-top: 150px;
    padding-bottom: 40px;
  }
}

/* Glow Effect CSS */
.glow-effect-bg {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 0;
  border-radius: 26843500px;
  opacity: 0.9926;
  background: #FB64B6;
  filter: blur(64px);
  width: 350px;
  height: 350px;
  opacity: 18%;
}

@media (min-width: 992px) {
  .glow-effect-bg {
    left: 0;
    transform: none;
  }
}



/* Badge */
.new-demo-badge {
  background: transparent;
  border: 1px solid #F2CC00;
  border-radius: 50px;
  height: 33px;
  padding: 0 12px;
  font-family: var(--font-inter-semibold);
  font-weight: 600;
  font-size: 17px;
  color: white;
}

@media (min-width: 768px) {}

@media (min-width: 992px) {}

/* Heading */
.new-demo-heading {
  font-family: var(--font-codec-cold, sans-serif);
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
}

@media (min-width: 768px) {
  .new-demo-heading {
    font-size: 44px;
  }
}

@media (min-width: 992px) {
  .new-demo-heading {
    font-size: 56px;
    line-height: 1.1;
  }
}

.new-demo-highlight {
  color: #F2CC00;
  font-style: italic;
}

.new-demo-tag {
  font-family: var(--font-codec-cold);
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
}

/* Description */
.new-demo-description {
  font-family: var(--font-montserrat-medium);
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #E2E2E2;
}


/* View Showcase Button */
.new-demo-showcase-btn {
  background: white;
  color: #6318C6;
  border: none;
  border-radius: 30px;
  padding: 5px 40px 0 40px;
  height: 48px;
  font-family: var(--font-codec-cold, sans-serif);
  font-size: 19px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

@media (min-width: 992px) {
  .new-demo-showcase-btn {
    font-size: 19px;
  }
}

.new-demo-showcase-btn:hover {
  background: #f0f0f0;
}

/* Images Container */
.new-demo-image-cards {
  background: #54018C;
  padding: 12px;
  border-radius: 20px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.4);
}

@media (min-width: 992px) {
  .new-demo-image-cards {
    padding: 23px;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    width: auto;
  }

  .new-demo-description {
    padding: 0 60px 0 0;
  }
}

.new-demo-card {
  border-radius: 12px;
  width: 100%;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .new-demo-card {
    max-width: 350px;
  }
}

@media (min-width: 992px) {
  .new-demo-card {
    border-radius: 16px;
    width: 320px;
  }
}

.new-demo-category-section {
  padding: 100px 0 100px 0;
}

@media (max-width: 768px) {
  .section-padding-1 {
    padding: 15px 0 25px 0 !important;
  }

  .new-demo-badge {
    font-size: 13px !important;
    letter-spacing: 0.2px;
  }

  .new-demo-heading {
    font-size: 23px !important;
  }

  .new-demo-showcase-btn {
    padding: 3px 30px 0 30px !important;
    height: 38px !important;
    font-size: 15px !important;
  }

  .new-demo-description {
    font-size: 14px;
    line-height: 23px !important;
  }

  .model-selection {
    top: 16% !important;
    left: -22px !important;
  }

  .new-demo-floating-badge {
    font-size: 12px !important;
  }

  .clothing-selection {
    top: 45% !important;
    right: -27px !important;
  }

  .new-demo-floating-badge svg {
    width: 20px;
    height: 20px;
    margin-right: 5px !important;
  }

  .new-demo-stat-item h2 {
    font-size: 28px !important;
  }

  .new-demo-main-section {
    border-bottom-right-radius: 38px !important;
    padding-bottom: 26px !important;
  }

  .new-demo-category-section {
    padding: 50px 0 40px 0 !important;
  }

  .new-demo-category-title {
    font-size: 23px !important;
    line-height: 1.2 !important;
  }

  .new-demo-category-subtitle {
    font-size: 15px !important;
    line-height: 23px !important;
  }
}

.new-demo-product-img-wrap {
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
}

.new-demo-product-img {
  width: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.new-demo-card:hover .new-demo-product-img {
  transform: scale(1.05);
}

@media (min-width: 992px) {
  .new-demo-product-img-wrap {
    border-radius: 16px;
  }
}

/* Tags */
.new-demo-tag {
  font-size: 10px;
  padding: 4px 10px;
  border-radius: 20px;
  z-index: 10;
  text-transform: uppercase;
}

@media (min-width: 992px) {
  .new-demo-tag {
    font-size: 13px;
    padding: 6px 16px;
  }
}

.before-tag {
  background: rgba(60, 60, 60, 0.8);
  color: white;
}

.after-tag {
  background: #F2CC00;
  font-family: var(--font-inter-medium);
  color: #000;
}

/* Floating Badges */
.new-demo-floating-badge {
  background: linear-gradient(90deg, rgba(71, 18, 140, 0.88) 0%, rgba(74, 85, 101, 0.88) 100%);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: white;
  font-family: var(--font-inter-medium);
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 30px;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  animation: float-badge 3s ease-in-out infinite;
}

@keyframes float-badge {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-8px);
  }

  100% {
    transform: translateY(0);
  }
}

.model-selection {
  top: 35%;
  left: 10px;
  animation-delay: 0s;
}

@media (min-width: 768px) {
  .model-selection {
    left: -20px;
  }
}

@media (min-width: 992px) {
  .model-selection {
    left: -104px;
    top: 23%;
  }
}

.face-selection {
  bottom: 12px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: max-content;
  animation-delay: 1.5s;
}

@media (min-width: 992px) {
  .face-selection {
    bottom: 10px;
  }
}

.clothing-selection {
  top: 45%;
  right: 10px;
  animation-delay: 0.75s;
}

@media (min-width: 768px) {
  .clothing-selection {
    right: -20px;
  }
}

@media (min-width: 992px) {
  .clothing-selection {
    top: 48%;
    right: -90px;
  }
}

/* Stats Section */
.new-demo-stats-container {
  background: rgba(36, 9, 70, 0.45);
  border-radius: 20px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); */
}

.new-demo-stat-item h2 {
  font-family: var(--font-inter-semibold), 'Inter', sans-serif;
  font-size: 35px;
  font-weight: 700;
  color: #F2CC00;
  margin: 0 0 6px 0;
}

@media (min-width: 992px) {
  .new-demo-stat-item h2 {
    font-size: 35px;
    margin: 0 0 8px 0;
  }
}

.new-demo-stat-item p {
  font-family: var(--font-codec-cold), sans-serif;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: white;
}

@media (min-width: 992px) {
  .new-demo-stat-item p {
    font-size: 19px;
  }
}

.section-padding-1 {
  padding: 15px 0 25px 0;
}

/* Category Section */

.new-demo-category-badge {
  background: rgba(205, 191, 166, 0.41);
  /* border: 1px solid rgba(255, 255, 255, 0.2); */
  color: white;
  padding: 6px 25px;
  border-radius: 50px;
  font-family: var(--font-inter-medium);
  font-size: 16px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-demo-category-title {
  color: #F2CC00;
  font-family: var(--font-codec-cold);
  font-weight: bold;
  font-size: 45px;
}


.new-demo-category-subtitle {
  color: white;
  font-family: var(--font-codec-cold-regular);
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
}

/* Category Slider & Grid */
.new-demo-category-slider {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  gap: 16px;
  padding-bottom: 20px;
}

/* Hide scrollbar for slider */
.new-demo-category-slider::-webkit-scrollbar {
  display: none;
}

.new-demo-category-slider {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.new-demo-category-card {
  flex: 0 0 75%;
  /* Mobile width */
  scroll-snap-align: center;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  height: 320px;
}

.new-demo-category-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.new-demo-category-card:hover img {
  transform: scale(1.05);
}

.new-demo-category-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, rgba(99, 24, 198, 0.42) 100%);
  display: flex;
  align-items: flex-end;
  padding: 24px;
}

.new-demo-category-title-text {
  font-family: var(--font-codec-cold-medium);
  font-size: 17px;
  font-weight: 500;
  color: white;
  margin: 0;
}

@media (min-width: 768px) {
  .new-demo-category-slider {
    flex-wrap: wrap;
    justify-content: center;
    overflow-x: visible;
  }

  .new-demo-category-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.333% - 16px);
    height: 320px;
  }
}

@media (min-width: 992px) {
  .new-demo-category-slider {
    flex-wrap: nowrap;
    overflow-x: visible;
    gap: 20px;
    padding: 0 15px;
  }

  .new-demo-category-card {
    flex: 1 1;
    min-width: 0;
    height: 320px;
  }
}

/* ===================== */
/* Transformation Section */
/* ===================== */
.tf-section {
  padding: 80px 0;
  background-color: #ffffff;
  border-radius: 100px 100px 0 0;
}

.tf-container {
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 35px;
  padding-right: 35px;
  box-sizing: border-box;
}

/* Section Header */
.tf-section-badge {
  background: rgba(205, 191, 166, 0.4);
  color: #4A5565;
  padding: 6px 25px;
  border-radius: 50px;
  font-family: var(--font-inter-medium);
  font-size: 16px;
  height: 36px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.tf-section-title {
  font-family: var(--font-codec-cold);
  font-weight: bold;
  color: #6318C6;
  font-size: 45px;
  line-height: 1.15;
}

.tf-section-subtitle {
  color: #4A5565;
  font-family: var(--font-codec-cold-regular);
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
}

/* Cards Grid */
.tf-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 768px) {
  .tf-grid {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
}

/* Individual Card */
.tf-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #E6E6E6;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.tf-card-title {
  font-family: var(--font-codec-cold);
  font-weight: bold;
  font-size: 22px;
  color: #6318C6;
  margin: 0;
}

.tf-ai-badge {
  background: oklch(93% 0.03 300);
  color: oklch(34% 0.22 300);
  border-radius: 30px;
  padding: 5px 14px;
  font-family: var(--font-inter-semibold);
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

/* Card Body Layout */
.tf-card-body {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}

/* ---- LEFT: Source Panel (40%) ---- */
.tf-source-panel {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(40% - 22px);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
}

/* Product source image container */
.tf-source-img-wrap {
  background: oklch(97% 0.006 300);
  border-radius: 10px;
  width: 100%;
  height: 262px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}

.tf-source-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* ---- CENTRE: Arrow Column ---- */
.tf-arrow-col {
  flex: 0 0 28px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  /* Align arrow with top grey bar: bar margin(6) + bar height(14)/2 - icon height(20)/2 ≈ 9px */
  padding-top: 9px;
  color: #6318C6;
}

/* ---- RIGHT: Generated Panel (60%) ---- */
.tf-generated-panel {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.tf-generated-img-wrap {
  border-radius: 16px;
  overflow: hidden;
  width: 100%;
  height: 580px;
  position: relative;
}

.tf-generated-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease, opacity 0.3s ease;
}

.tf-generated-img-wrap:hover .tf-generated-img {
  transform: scale(1.05);
}

.tf-photos-badge {
  background: rgba(0, 0, 0, 0.55);
  color: white;
  border-radius: 20px;
  padding: 3px 10px;
  font-family: var(--font-inter-medium);
  font-size: 11px;
}

/* Labels */
.tf-label {
  font-family: var(--font-inter-semibold);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: oklch(63% 0.015 300);
  display: flex;
  align-items: center;
  gap: 5px;
  text-transform: uppercase;
  margin-top: 8px;
  margin-bottom: 6px;
}

.tf-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tf-dot-gray {
  background: #999;
}

.tf-dot-purple {
  background: #6318C6;
}

/* Thumbnails */
.tf-thumbnails {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tf-thumb-btn {
  background: none;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  transition: border-color 0.2s, transform 0.2s;
  overflow: hidden;
  width: 52px;
  height: 75px;
  flex-shrink: 0;
}

.tf-thumb-btn:hover {
  transform: scale(1.05);
}

.tf-thumb-btn.active {
  border-color: #6318C6;
}

.tf-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  display: block;
}

/* ---- Responsive ---- */
@media (max-width: 767px) {
  .tf-container {
    padding-left: 16px;
    padding-right: 16px;
  }

  .tf-section {
    padding: 48px 0;
    border-radius: 38px 38px 0 0;
  }

  .tf-section-title {
    font-size: 23px !important;
    line-height: 1.2 !important;
  }

  .new-demo-category-badge,
  .tf-section-badge {
    font-size: 15px !important;
  }

  .tf-section-subtitle {
    font-size: 15px;
    line-height: 23px !important;
  }

  .tf-source-img-wrap {
    height: 150px;
  }


  .tf-generated-img-wrap {
    height: 240px;
  }

  .tf-thumb-btn {
    width: 45px;
    height: 70px;
  }

  .tf-card-title {
    font-size: 17px !important;
  }

  .tf-card {
    padding: 15px;
  }

  .tf-arrow-col {
    flex: 0 0 19px !important;
    padding-top: 0px !important;
  }

  .tf-label {
    font-size: 9px !important;
  }

  .mf-badge,
  .sd-badge {
    padding: 6px 25px !important;
    font-size: 15px !important;
  }

  .mf-title {
    font-size: 23px !important;
    line-height: 1.2 !important;
    text-align: center;
  }

  .mf-title,
  .sd-title {
    /* font-size: 22px; */
    font-size: 23px !important;
    line-height: 1.2 !important;
    text-align: center;
  }

  .df-logo-col {
    flex: 0 0 auto;
    text-align: center;
    width: 100%;
  }

  .df-contact-col {
    display: block !important;
    width: 100%;
  }

  .df-contact-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .df-contact-link {
    gap: 5px !important;
    font-size: 15px !important;
    margin: 10px !important;
  }

  .df-apps-col {
    justify-content: center !important;
  }

  .df-copyright,
  .df-link {
    font-size: 12px !important;
  }

  .df-logo {
    height: 52px !important;
  }

  .sd-subtitle {
    font-size: 15px !important;
    line-height: 23px !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .tf-container {
    padding-left: 32px;
    padding-right: 32px;
  }

  .tf-source-img-wrap {
    height: 180px;
  }

  .tf-generated-img-wrap {
    height: 280px;
  }
}

/* ================================ */
/* Multiple Formats Section         */
/* ================================ */
.mf-section {
  background-color: #240946;
  padding: 80px 0;
}

.mf-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 35px;
  padding-right: 35px;
  box-sizing: border-box;
}

/* Left content */
.mf-left {
  flex: 0 0 47%;
  color: white;
}

.mf-badge {
  display: inline-block;
  background: rgba(205, 191, 166, 0.4);
  color: rgba(255, 255, 255, 1);
  border-radius: 50px;
  padding: 5px 18px;
  font-family: var(--font-inter-medium);
  font-size: 16px;
  margin-bottom: 25px;
}

.mf-title {
  font-family: var(--font-codec-cold);
  font-weight: bold;
  font-size: 45px;
  line-height: 1.2;
  color: white;
  margin-bottom: 24px;
}

.mf-pill-row {
  display: flex;
  gap: 10px;
}

.mf-pill {
  background: #6318C6;
  color: white;
  border-radius: 50px;
  padding: 6px 22px;
  font-family: var(--font-inter-medium);
  font-size: 13px;
  font-weight: 500;
}

/* Right format cards */
.mf-cards-row {
  display: flex;
  gap: 16px;
  flex: 1 1;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.mf-cards-row::-webkit-scrollbar {
  display: none;
}

.mf-format-card {
  flex: 0 0 auto;
  width: 150px;
}

.mf-format-img-wrap {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 10px;
}

.mf-format-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.mf-format-card:hover .mf-format-img {
  transform: scale(1.05);
}

.mf-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.mf-format-label {
  font-family: var(--font-inter-semibold);
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  text-transform: capitalize;
  margin: 0 0 2px 0;
}

.mf-format-sublabel {
  font-family: var(--font-inter-regular);
  font-size: 11px;
  color: #8A8070;
  margin: 0 0 2px 0;
}

/* Responsive – Multiple Formats */
@media (max-width: 991px) {
  .mf-section {
    padding: 50px 0;
  }

  .mf-inner {
    padding-left: 32px;
    padding-right: 32px;
  }

  .mf-left {
    flex: none;
    width: 100%;
    text-align: center;
  }

  .mf-pill-row {
    justify-content: center;
  }

  .sd-section {
    padding: 20px 0 20px 0 !important;
  }


  .mf-cards-row {
    width: 100%;
    overflow-x: auto;
  }

  .mf-format-card {
    width: 130px;
  }

  .mf-format-img-wrap {
    height: 170px;
  }
}

@media (max-width: 575px) {
  .mf-section {
    padding: 40px 0;
  }

  .mf-format-card {
    width: 115px;
  }

  .mf-format-img-wrap {
    height: 145px;
  }
}

/* ================================ */
/* Studio on Demand Section         */
/* ================================ */
.sd-section {
  background-color: #ffffff;
  padding: 80px 0;
}

.sd-card {
  background: linear-gradient(to bottom right, #59168B 0%, #8200DB 50%, #340753 100%);
  border-radius: 28px;
  padding: 60px 40px;
  text-align: center;
  width: calc(100% - 160px);
  max-width: 1350px;
  margin-left: auto;
  margin-right: auto;
}

.sd-badge {
  display: inline-block;
  background: rgba(205, 191, 166, 0.4);
  color: rgba(255, 255, 255, 0.9);
  border-radius: 50px;
  padding: 6px 20px;
  font-family: var(--font-inter-medium);
  font-size: 17px;
  margin-bottom: 24px;
}

.sd-title {
  font-family: var(--font-codec-cold);
  font-weight: bold;
  font-size: 64px;
  color: white;
  line-height: 1.15;
  margin-bottom: 20px;
}

.sd-highlight {
  color: #F2CC00;
}

.sd-subtitle {
  font-family: var(--font-inter-regular);
  font-size: 24px;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  margin-bottom: 36px;
}

.sd-btn {
  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 0 36px;
  height: 48px;
  font-family: var(--font-codec-cold), sans-serif;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 0.2px;
}

.sd-btn:hover {
  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

/* Responsive – Studio Demand */
@media (max-width: 991px) {
  .sd-section {
    padding: 0 0 60px 0;
  }

  .sd-title {
    font-size: 36px;
  }

  .sd-subtitle {
    font-size: 17px;
  }

  .sd-card {
    padding: 50px 30px;
    width: calc(100% - 64px);
  }
}

@media (max-width: 575px) {
  .sd-section {
    padding: 0 0 48px 0;
  }

  .sd-title {
    font-size: 26px;
    line-height: 1.2;
  }

  .sd-subtitle {
    font-size: 15px;
    line-height: 24px;
  }

  .sd-card {
    padding: 40px 20px;
    border-radius: 20px;
    width: calc(100% - 32px);
  }

  .sd-btn {
    font-size: 16px;
    padding: 0 28px;
    height: 46px;
  }
}

/* ================================ */
/* Demo Footer                      */
/* ================================ */
.df-footer {
  background-color: #240946;
  padding: 0;
}

.df-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
}

/* Logo */
.df-logo-col {
  flex: 0 0 auto;
}

.df-logo {
  /* height: 52px; */
  object-fit: contain;
}

.df-logo-fallback {
  flex-direction: column;
  align-items: flex-start;
}

.df-logo-text {
  font-size: 26px;
  font-weight: 800;
  font-family: var(--font-codec-cold);
}

.df-logo-g {
  color: #F2CC00;
}

.df-logo-lammify {
  color: white;
}

.df-logo-tagline {
  font-family: var(--font-inter-medium);
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.5);
  margin: 2px 0 0 0;
}

/* Contact */
.df-contact-col {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
}

.df-contact-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  text-decoration: none;
  font-family: var(--font-inter-medium);
  font-size: 20px;
  transition: opacity 0.2s;
}

.df-contact-link:hover {
  opacity: 0.75;
  color: white;
}

.df-apps-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.df-store-btn {
  display: inline-block;
  transition: transform 0.2s, opacity 0.2s;
}

.df-store-btn:hover {
  transform: translateY(-1px);
  opacity: 0.9;
}

.df-store-btn img {
  /* height: 44px; */
  object-fit: contain;
  display: block;
}

/* Divider */
.df-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 32px 0 20px 0;
}

/* Bottom Row */
.df-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.df-copyright {
  font-family: var(--font-inter-regular);
  font-size: 16px;
  color: #D5D4D4;
}

.df-links {
  display: flex;
  gap: 32px;
}

.df-link {
  font-family: var(--font-inter-regular);
  font-size: 16px;
  color: #D5D4D4;
  text-decoration: none;
  transition: color 0.2s;
}

.df-link:hover {
  color: white;
}

/* Responsive – Footer */
@media (max-width: 991px) {
  .df-footer {
    padding: 0;
  }

  .df-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 28px;
  }

  .df-apps-col {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .df-bottom {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 575px) {
  .df-footer {
    padding: 0;
  }

  .df-store-btn {
    min-width: 150px;
  }

  .df-links {
    gap: 20px;
  }
}

@media (min-width: 1025px) and (max-width: 1359px) {
  .demo-content-container {
    max-width: 1158px;
  }

  .clothing-selection {
    top: 48%;
    right: -63px;
  }

  .mf-title,
  .tf-section-title {
    font-size: 36px;
  }

  .mf-inner {
    gap: 0px;
    padding-left: 50px;
    padding-right: 50px;
  }

  .mf-format-card {
    width: 132px;
  }

  .tf-section-subtitle {
    font-size: 19px;
  }

  .new-demo-image-cards {
    width: 100%;
  }

  .new-demo-description {
    padding: 0 0px 0 0;
    font-size: 19px;
  }

  .new-demo-showcase-btn {
    padding: 2px 40px 0 40px;
    height: 42px;
    font-size: 16px;
  }

  .new-demo-showcase-btn {
    font-size: 16px;
  }

  .new-demo-heading {
    font-size: 43px;
  }
}

@media (min-width: 1360px) and (max-width: 1400px) {
  .demo-content-container {
    max-width: 1360px;
  }

  .new-demo-description {
    padding: 0 75px 0 0;
    font-size: 18px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Merchant/Profile/demo/index.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qEAAqE;EACrE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE;;;mBAGiB;EACjB,+EAA+E;EAC/E,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,iCAAiC;IACjC,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,OAAO;IACP,eAAe;EACjB;AACF;;;;AAIA,UAAU;AACV;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA,2BAA2B;;AAE3B,2BAA2B;;AAE3B,YAAY;AACZ;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;;AAGA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mCAAmC;IACnC,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2CAA2C;IAC3C,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,SAAS;AACT;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,4FAA4F;EAC5F,0CAA0C;EAC1C,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,QAAQ;EACV;AACF;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;;AAErB;EACE,qCAAqC;EACrC,gDAAgD;EAChD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,uBAAuB;EACvB,SAAS;EACT,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yFAAyF;EACzF,aAAa;EACb,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;IAC9B,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAW;IACX,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,0BAA0B;AAC1B,2BAA2B;AAC3B,0BAA0B;AAC1B;EACE,eAAe;EACf,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,uCAAuC;AACvC;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;AACR;;AAEA,mCAAmC;AACnC;EACE,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,8FAA8F;EAC9F,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;;IAEE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;AACrC;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,SAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;EACnC;;;EAGA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;AACrC;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mFAAmF;EACnF,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;EACd;AACF;;AAEA,qCAAqC;AACrC,qCAAqC;AACrC,qCAAqC;AACrC;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF","sourcesContent":["/* Page Background */\n.new-demo-page-container {\n  min-height: 100vh;\n  background-color: #240946;\n  padding: 0;\n  position: relative;\n  overflow-x: hidden;\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n}\n\n/* Core Container System */\n.demo-content-container {\n  width: 100%;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 20px;\n  padding-right: 20px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 991px) {\n  .demo-content-container {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n}\n\n@media (max-width: 767px) {\n  .demo-content-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .tf-thumbnails {\n    gap: 2px !important;\n  }\n}\n\n/* Header */\n.demo-header {\n  background: #ffffff;\n  border-radius: 50px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10), inset 0 0 0 1.5px #B9B9B9;\n  width: 95%;\n  height: 70px;\n  max-width: 1400px;\n  z-index: 1000;\n  position: fixed;\n  top: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 0 15px;\n}\n\n@media (min-width: 768px) {\n  .demo-header {\n    height: 80px;\n    padding: 0 20px;\n  }\n}\n\n@media (min-width: 992px) {\n  .demo-header {\n    height: 100px;\n    padding: 0 40px;\n  }\n}\n\n.demo-logo {\n  height: 32px;\n  object-fit: contain;\n}\n\n@media (min-width: 768px) {\n  .demo-logo {\n    height: 40px;\n  }\n}\n\n@media (min-width: 992px) {\n  .demo-logo {\n    height: 60px;\n  }\n}\n\n/* Try Glammify Button */\n.new-demo-try-btn {\n  padding: 0 16px;\n  height: 36px;\n  border-radius: 30px;\n  background: linear-gradient(90deg, #6318C6 0%, #D89824 100%);\n  color: white;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s;\n  font-family: var(--font-codec-cold, sans-serif);\n}\n\n@media (min-width: 768px) {\n  .new-demo-try-btn {\n    padding: 3px 28px 0px 28px;\n    height: 40px;\n    font-size: 15px;\n  }\n}\n\n@media (min-width: 992px) {\n  .new-demo-try-btn {\n    padding: 0 28px;\n    height: 48px;\n    font-size: 19px;\n  }\n}\n\n.new-demo-try-btn:hover {\n  opacity: 0.9;\n}\n\n/* Main Section Background */\n.new-demo-main-section {\n  background: linear-gradient(135deg,\n      #59168B 0%,\n      #8200DB 50%,\n      #9810FA 100%);\n  /* background: linear-gradient(90deg, #59168B 0%, #8200DB 50%, #9810FA 100%); */\n  border-bottom-right-radius: 80px;\n  padding-top: 110px;\n  /* Space for fixed header */\n  padding-bottom: 60px;\n  color: white;\n  position: relative;\n  overflow: hidden;\n}\n\n@media (min-width: 768px) {\n  .new-demo-main-section {\n    border-bottom-right-radius: 238px;\n    padding-top: 150px;\n    padding-bottom: 40px;\n  }\n}\n\n@media (min-width: 992px) {\n  .new-demo-main-section {\n    border-bottom-right-radius: 238px;\n    padding-top: 150px;\n    padding-bottom: 40px;\n  }\n}\n\n/* Glow Effect CSS */\n.glow-effect-bg {\n  position: absolute;\n  top: -50px;\n  left: 50%;\n  transform: translateX(-50%);\n  pointer-events: none;\n  z-index: 0;\n  border-radius: 26843500px;\n  opacity: 0.9926;\n  background: #FB64B6;\n  filter: blur(64px);\n  width: 350px;\n  height: 350px;\n  opacity: 18%;\n}\n\n@media (min-width: 992px) {\n  .glow-effect-bg {\n    left: 0;\n    transform: none;\n  }\n}\n\n\n\n/* Badge */\n.new-demo-badge {\n  background: transparent;\n  border: 1px solid #F2CC00;\n  border-radius: 50px;\n  height: 33px;\n  padding: 0 12px;\n  font-family: var(--font-inter-semibold);\n  font-weight: 600;\n  font-size: 17px;\n  color: white;\n}\n\n@media (min-width: 768px) {}\n\n@media (min-width: 992px) {}\n\n/* Heading */\n.new-demo-heading {\n  font-family: var(--font-codec-cold, sans-serif);\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n@media (min-width: 768px) {\n  .new-demo-heading {\n    font-size: 44px;\n  }\n}\n\n@media (min-width: 992px) {\n  .new-demo-heading {\n    font-size: 56px;\n    line-height: 1.1;\n  }\n}\n\n.new-demo-highlight {\n  color: #F2CC00;\n  font-style: italic;\n}\n\n.new-demo-tag {\n  font-family: var(--font-codec-cold);\n  font-weight: bold;\n  font-size: 13px;\n  text-transform: uppercase;\n}\n\n/* Description */\n.new-demo-description {\n  font-family: var(--font-montserrat-medium);\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  color: #E2E2E2;\n}\n\n\n/* View Showcase Button */\n.new-demo-showcase-btn {\n  background: white;\n  color: #6318C6;\n  border: none;\n  border-radius: 30px;\n  padding: 5px 40px 0 40px;\n  height: 48px;\n  font-family: var(--font-codec-cold, sans-serif);\n  font-size: 19px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n@media (min-width: 992px) {\n  .new-demo-showcase-btn {\n    font-size: 19px;\n  }\n}\n\n.new-demo-showcase-btn:hover {\n  background: #f0f0f0;\n}\n\n/* Images Container */\n.new-demo-image-cards {\n  background: #54018C;\n  padding: 12px;\n  border-radius: 20px;\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);\n  width: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.4);\n}\n\n@media (min-width: 992px) {\n  .new-demo-image-cards {\n    padding: 23px;\n    border-radius: 24px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n    width: auto;\n  }\n\n  .new-demo-description {\n    padding: 0 60px 0 0;\n  }\n}\n\n.new-demo-card {\n  border-radius: 12px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n  .new-demo-card {\n    max-width: 350px;\n  }\n}\n\n@media (min-width: 992px) {\n  .new-demo-card {\n    border-radius: 16px;\n    width: 320px;\n  }\n}\n\n.new-demo-category-section {\n  padding: 100px 0 100px 0;\n}\n\n@media (max-width: 768px) {\n  .section-padding-1 {\n    padding: 15px 0 25px 0 !important;\n  }\n\n  .new-demo-badge {\n    font-size: 13px !important;\n    letter-spacing: 0.2px;\n  }\n\n  .new-demo-heading {\n    font-size: 23px !important;\n  }\n\n  .new-demo-showcase-btn {\n    padding: 3px 30px 0 30px !important;\n    height: 38px !important;\n    font-size: 15px !important;\n  }\n\n  .new-demo-description {\n    font-size: 14px;\n    line-height: 23px !important;\n  }\n\n  .model-selection {\n    top: 16% !important;\n    left: -22px !important;\n  }\n\n  .new-demo-floating-badge {\n    font-size: 12px !important;\n  }\n\n  .clothing-selection {\n    top: 45% !important;\n    right: -27px !important;\n  }\n\n  .new-demo-floating-badge svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 5px !important;\n  }\n\n  .new-demo-stat-item h2 {\n    font-size: 28px !important;\n  }\n\n  .new-demo-main-section {\n    border-bottom-right-radius: 38px !important;\n    padding-bottom: 26px !important;\n  }\n\n  .new-demo-category-section {\n    padding: 50px 0 40px 0 !important;\n  }\n\n  .new-demo-category-title {\n    font-size: 23px !important;\n    line-height: 1.2 !important;\n  }\n\n  .new-demo-category-subtitle {\n    font-size: 15px !important;\n    line-height: 23px !important;\n  }\n}\n\n.new-demo-product-img-wrap {\n  border-radius: 12px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.new-demo-product-img {\n  width: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.new-demo-card:hover .new-demo-product-img {\n  transform: scale(1.05);\n}\n\n@media (min-width: 992px) {\n  .new-demo-product-img-wrap {\n    border-radius: 16px;\n  }\n}\n\n/* Tags */\n.new-demo-tag {\n  font-size: 10px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  z-index: 10;\n  text-transform: uppercase;\n}\n\n@media (min-width: 992px) {\n  .new-demo-tag {\n    font-size: 13px;\n    padding: 6px 16px;\n  }\n}\n\n.before-tag {\n  background: rgba(60, 60, 60, 0.8);\n  color: white;\n}\n\n.after-tag {\n  background: #F2CC00;\n  font-family: var(--font-inter-medium);\n  color: #000;\n}\n\n/* Floating Badges */\n.new-demo-floating-badge {\n  background: linear-gradient(90deg, rgba(71, 18, 140, 0.88) 0%, rgba(74, 85, 101, 0.88) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  color: white;\n  font-family: var(--font-inter-medium);\n  font-size: 14px;\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: 30px;\n  z-index: 10;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  white-space: nowrap;\n  animation: float-badge 3s ease-in-out infinite;\n}\n\n@keyframes float-badge {\n  0% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-8px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.model-selection {\n  top: 35%;\n  left: 10px;\n  animation-delay: 0s;\n}\n\n@media (min-width: 768px) {\n  .model-selection {\n    left: -20px;\n  }\n}\n\n@media (min-width: 992px) {\n  .model-selection {\n    left: -104px;\n    top: 23%;\n  }\n}\n\n.face-selection {\n  bottom: 12px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: max-content;\n  animation-delay: 1.5s;\n}\n\n@media (min-width: 992px) {\n  .face-selection {\n    bottom: 10px;\n  }\n}\n\n.clothing-selection {\n  top: 45%;\n  right: 10px;\n  animation-delay: 0.75s;\n}\n\n@media (min-width: 768px) {\n  .clothing-selection {\n    right: -20px;\n  }\n}\n\n@media (min-width: 992px) {\n  .clothing-selection {\n    top: 48%;\n    right: -90px;\n  }\n}\n\n/* Stats Section */\n.new-demo-stats-container {\n  background: rgba(36, 9, 70, 0.45);\n  border-radius: 20px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); */\n}\n\n.new-demo-stat-item h2 {\n  font-family: var(--font-inter-semibold), 'Inter', sans-serif;\n  font-size: 35px;\n  font-weight: 700;\n  color: #F2CC00;\n  margin: 0 0 6px 0;\n}\n\n@media (min-width: 992px) {\n  .new-demo-stat-item h2 {\n    font-size: 35px;\n    margin: 0 0 8px 0;\n  }\n}\n\n.new-demo-stat-item p {\n  font-family: var(--font-codec-cold), sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0;\n  color: white;\n}\n\n@media (min-width: 992px) {\n  .new-demo-stat-item p {\n    font-size: 19px;\n  }\n}\n\n.section-padding-1 {\n  padding: 15px 0 25px 0;\n}\n\n/* Category Section */\n\n.new-demo-category-badge {\n  background: rgba(205, 191, 166, 0.41);\n  /* border: 1px solid rgba(255, 255, 255, 0.2); */\n  color: white;\n  padding: 6px 25px;\n  border-radius: 50px;\n  font-family: var(--font-inter-medium);\n  font-size: 16px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.new-demo-category-title {\n  color: #F2CC00;\n  font-family: var(--font-codec-cold);\n  font-weight: bold;\n  font-size: 45px;\n}\n\n\n.new-demo-category-subtitle {\n  color: white;\n  font-family: var(--font-codec-cold-regular);\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 32px;\n}\n\n/* Category Slider & Grid */\n.new-demo-category-slider {\n  display: flex;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n  gap: 16px;\n  padding-bottom: 20px;\n}\n\n/* Hide scrollbar for slider */\n.new-demo-category-slider::-webkit-scrollbar {\n  display: none;\n}\n\n.new-demo-category-slider {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.new-demo-category-card {\n  flex: 0 0 75%;\n  /* Mobile width */\n  scroll-snap-align: center;\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  height: 320px;\n}\n\n.new-demo-category-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.new-demo-category-card:hover img {\n  transform: scale(1.05);\n}\n\n.new-demo-category-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, rgba(99, 24, 198, 0.42) 100%);\n  display: flex;\n  align-items: flex-end;\n  padding: 24px;\n}\n\n.new-demo-category-title-text {\n  font-family: var(--font-codec-cold-medium);\n  font-size: 17px;\n  font-weight: 500;\n  color: white;\n  margin: 0;\n}\n\n@media (min-width: 768px) {\n  .new-demo-category-slider {\n    flex-wrap: wrap;\n    justify-content: center;\n    overflow-x: visible;\n  }\n\n  .new-demo-category-card {\n    flex: 0 0 calc(33.333% - 16px);\n    height: 320px;\n  }\n}\n\n@media (min-width: 992px) {\n  .new-demo-category-slider {\n    flex-wrap: nowrap;\n    overflow-x: visible;\n    gap: 20px;\n    padding: 0 15px;\n  }\n\n  .new-demo-category-card {\n    flex: 1 1 0;\n    min-width: 0;\n    height: 320px;\n  }\n}\n\n/* ===================== */\n/* Transformation Section */\n/* ===================== */\n.tf-section {\n  padding: 80px 0;\n  background-color: #ffffff;\n  border-radius: 100px 100px 0 0;\n}\n\n.tf-container {\n  width: 100%;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 35px;\n  padding-right: 35px;\n  box-sizing: border-box;\n}\n\n/* Section Header */\n.tf-section-badge {\n  background: rgba(205, 191, 166, 0.4);\n  color: #4A5565;\n  padding: 6px 25px;\n  border-radius: 50px;\n  font-family: var(--font-inter-medium);\n  font-size: 16px;\n  height: 36px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.tf-section-title {\n  font-family: var(--font-codec-cold);\n  font-weight: bold;\n  color: #6318C6;\n  font-size: 45px;\n  line-height: 1.15;\n}\n\n.tf-section-subtitle {\n  color: #4A5565;\n  font-family: var(--font-codec-cold-regular);\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 32px;\n}\n\n/* Cards Grid */\n.tf-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n}\n\n@media (min-width: 768px) {\n  .tf-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n}\n\n/* Individual Card */\n.tf-card {\n  background: #ffffff;\n  border-radius: 24px;\n  padding: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  border: 1px solid #E6E6E6;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.tf-card-title {\n  font-family: var(--font-codec-cold);\n  font-weight: bold;\n  font-size: 22px;\n  color: #6318C6;\n  margin: 0;\n}\n\n.tf-ai-badge {\n  background: oklch(93% 0.03 300);\n  color: oklch(34% 0.22 300);\n  border-radius: 30px;\n  padding: 5px 14px;\n  font-family: var(--font-inter-semibold);\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* Card Body Layout */\n.tf-card-body {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n/* ---- LEFT: Source Panel (40%) ---- */\n.tf-source-panel {\n  flex: 0 0 calc(40% - 22px);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n}\n\n/* Product source image container */\n.tf-source-img-wrap {\n  background: oklch(97% 0.006 300);\n  border-radius: 10px;\n  width: 100%;\n  height: 262px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 0;\n}\n\n.tf-source-img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n/* ---- CENTRE: Arrow Column ---- */\n.tf-arrow-col {\n  flex: 0 0 28px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  /* Align arrow with top grey bar: bar margin(6) + bar height(14)/2 - icon height(20)/2 ≈ 9px */\n  padding-top: 9px;\n  color: #6318C6;\n}\n\n/* ---- RIGHT: Generated Panel (60%) ---- */\n.tf-generated-panel {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.tf-generated-img-wrap {\n  border-radius: 16px;\n  overflow: hidden;\n  width: 100%;\n  height: 580px;\n  position: relative;\n}\n\n.tf-generated-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease, opacity 0.3s ease;\n}\n\n.tf-generated-img-wrap:hover .tf-generated-img {\n  transform: scale(1.05);\n}\n\n.tf-photos-badge {\n  background: rgba(0, 0, 0, 0.55);\n  color: white;\n  border-radius: 20px;\n  padding: 3px 10px;\n  font-family: var(--font-inter-medium);\n  font-size: 11px;\n}\n\n/* Labels */\n.tf-label {\n  font-family: var(--font-inter-semibold);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: oklch(63% 0.015 300);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  text-transform: uppercase;\n  margin-top: 8px;\n  margin-bottom: 6px;\n}\n\n.tf-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.tf-dot-gray {\n  background: #999;\n}\n\n.tf-dot-purple {\n  background: #6318C6;\n}\n\n/* Thumbnails */\n.tf-thumbnails {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tf-thumb-btn {\n  background: none;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  padding: 0;\n  cursor: pointer;\n  transition: border-color 0.2s, transform 0.2s;\n  overflow: hidden;\n  width: 52px;\n  height: 75px;\n  flex-shrink: 0;\n}\n\n.tf-thumb-btn:hover {\n  transform: scale(1.05);\n}\n\n.tf-thumb-btn.active {\n  border-color: #6318C6;\n}\n\n.tf-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 6px;\n  display: block;\n}\n\n/* ---- Responsive ---- */\n@media (max-width: 767px) {\n  .tf-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .tf-section {\n    padding: 48px 0;\n    border-radius: 38px 38px 0 0;\n  }\n\n  .tf-section-title {\n    font-size: 23px !important;\n    line-height: 1.2 !important;\n  }\n\n  .new-demo-category-badge,\n  .tf-section-badge {\n    font-size: 15px !important;\n  }\n\n  .tf-section-subtitle {\n    font-size: 15px;\n    line-height: 23px !important;\n  }\n\n  .tf-source-img-wrap {\n    height: 150px;\n  }\n\n\n  .tf-generated-img-wrap {\n    height: 240px;\n  }\n\n  .tf-thumb-btn {\n    width: 45px;\n    height: 70px;\n  }\n\n  .tf-card-title {\n    font-size: 17px !important;\n  }\n\n  .tf-card {\n    padding: 15px;\n  }\n\n  .tf-arrow-col {\n    flex: 0 0 19px !important;\n    padding-top: 0px !important;\n  }\n\n  .tf-label {\n    font-size: 9px !important;\n  }\n\n  .mf-badge,\n  .sd-badge {\n    padding: 6px 25px !important;\n    font-size: 15px !important;\n  }\n\n  .mf-title {\n    font-size: 23px !important;\n    line-height: 1.2 !important;\n    text-align: center;\n  }\n\n  .mf-title,\n  .sd-title {\n    /* font-size: 22px; */\n    font-size: 23px !important;\n    line-height: 1.2 !important;\n    text-align: center;\n  }\n\n  .df-logo-col {\n    flex: 0 0 auto;\n    text-align: center;\n    width: 100%;\n  }\n\n  .df-contact-col {\n    display: block !important;\n    width: 100%;\n  }\n\n  .df-contact-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .df-contact-link {\n    gap: 5px !important;\n    font-size: 15px !important;\n    margin: 10px !important;\n  }\n\n  .df-apps-col {\n    justify-content: center !important;\n  }\n\n  .df-copyright,\n  .df-link {\n    font-size: 12px !important;\n  }\n\n  .df-logo {\n    height: 52px !important;\n  }\n\n  .sd-subtitle {\n    font-size: 15px !important;\n    line-height: 23px !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .tf-container {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  .tf-source-img-wrap {\n    height: 180px;\n  }\n\n  .tf-generated-img-wrap {\n    height: 280px;\n  }\n}\n\n/* ================================ */\n/* Multiple Formats Section         */\n/* ================================ */\n.mf-section {\n  background-color: #240946;\n  padding: 80px 0;\n}\n\n.mf-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 48px;\n  width: 100%;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 35px;\n  padding-right: 35px;\n  box-sizing: border-box;\n}\n\n/* Left content */\n.mf-left {\n  flex: 0 0 47%;\n  color: white;\n}\n\n.mf-badge {\n  display: inline-block;\n  background: rgba(205, 191, 166, 0.4);\n  color: rgba(255, 255, 255, 1);\n  border-radius: 50px;\n  padding: 5px 18px;\n  font-family: var(--font-inter-medium);\n  font-size: 16px;\n  margin-bottom: 25px;\n}\n\n.mf-title {\n  font-family: var(--font-codec-cold);\n  font-weight: bold;\n  font-size: 45px;\n  line-height: 1.2;\n  color: white;\n  margin-bottom: 24px;\n}\n\n.mf-pill-row {\n  display: flex;\n  gap: 10px;\n}\n\n.mf-pill {\n  background: #6318C6;\n  color: white;\n  border-radius: 50px;\n  padding: 6px 22px;\n  font-family: var(--font-inter-medium);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Right format cards */\n.mf-cards-row {\n  display: flex;\n  gap: 16px;\n  flex: 1 1 0;\n  min-width: 0;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.mf-cards-row::-webkit-scrollbar {\n  display: none;\n}\n\n.mf-format-card {\n  flex: 0 0 auto;\n  width: 150px;\n}\n\n.mf-format-img-wrap {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  border-radius: 14px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.mf-format-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.mf-format-card:hover .mf-format-img {\n  transform: scale(1.05);\n}\n\n.mf-play-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 40px;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.55);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.mf-format-label {\n  font-family: var(--font-inter-semibold);\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  text-transform: capitalize;\n  margin: 0 0 2px 0;\n}\n\n.mf-format-sublabel {\n  font-family: var(--font-inter-regular);\n  font-size: 11px;\n  color: #8A8070;\n  margin: 0 0 2px 0;\n}\n\n/* Responsive – Multiple Formats */\n@media (max-width: 991px) {\n  .mf-section {\n    padding: 50px 0;\n  }\n\n  .mf-inner {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  .mf-left {\n    flex: none;\n    width: 100%;\n    text-align: center;\n  }\n\n  .mf-pill-row {\n    justify-content: center;\n  }\n\n  .sd-section {\n    padding: 20px 0 20px 0 !important;\n  }\n\n\n  .mf-cards-row {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .mf-format-card {\n    width: 130px;\n  }\n\n  .mf-format-img-wrap {\n    height: 170px;\n  }\n}\n\n@media (max-width: 575px) {\n  .mf-section {\n    padding: 40px 0;\n  }\n\n  .mf-format-card {\n    width: 115px;\n  }\n\n  .mf-format-img-wrap {\n    height: 145px;\n  }\n}\n\n/* ================================ */\n/* Studio on Demand Section         */\n/* ================================ */\n.sd-section {\n  background-color: #ffffff;\n  padding: 80px 0;\n}\n\n.sd-card {\n  background: linear-gradient(to bottom right, #59168B 0%, #8200DB 50%, #340753 100%);\n  border-radius: 28px;\n  padding: 60px 40px;\n  text-align: center;\n  width: calc(100% - 160px);\n  max-width: 1350px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sd-badge {\n  display: inline-block;\n  background: rgba(205, 191, 166, 0.4);\n  color: rgba(255, 255, 255, 0.9);\n  border-radius: 50px;\n  padding: 6px 20px;\n  font-family: var(--font-inter-medium);\n  font-size: 17px;\n  margin-bottom: 24px;\n}\n\n.sd-title {\n  font-family: var(--font-codec-cold);\n  font-weight: bold;\n  font-size: 64px;\n  color: white;\n  line-height: 1.15;\n  margin-bottom: 20px;\n}\n\n.sd-highlight {\n  color: #F2CC00;\n}\n\n.sd-subtitle {\n  font-family: var(--font-inter-regular);\n  font-size: 24px;\n  color: rgba(255, 255, 255, 1);\n  line-height: 30px;\n  margin-bottom: 36px;\n}\n\n.sd-btn {\n  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 0 36px;\n  height: 48px;\n  font-family: var(--font-codec-cold), sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s;\n  letter-spacing: 0.2px;\n}\n\n.sd-btn:hover {\n  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n/* Responsive – Studio Demand */\n@media (max-width: 991px) {\n  .sd-section {\n    padding: 0 0 60px 0;\n  }\n\n  .sd-title {\n    font-size: 36px;\n  }\n\n  .sd-subtitle {\n    font-size: 17px;\n  }\n\n  .sd-card {\n    padding: 50px 30px;\n    width: calc(100% - 64px);\n  }\n}\n\n@media (max-width: 575px) {\n  .sd-section {\n    padding: 0 0 48px 0;\n  }\n\n  .sd-title {\n    font-size: 26px;\n    line-height: 1.2;\n  }\n\n  .sd-subtitle {\n    font-size: 15px;\n    line-height: 24px;\n  }\n\n  .sd-card {\n    padding: 40px 20px;\n    border-radius: 20px;\n    width: calc(100% - 32px);\n  }\n\n  .sd-btn {\n    font-size: 16px;\n    padding: 0 28px;\n    height: 46px;\n  }\n}\n\n/* ================================ */\n/* Demo Footer                      */\n/* ================================ */\n.df-footer {\n  background-color: #240946;\n  padding: 0;\n}\n\n.df-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  flex-wrap: wrap;\n}\n\n/* Logo */\n.df-logo-col {\n  flex: 0 0 auto;\n}\n\n.df-logo {\n  /* height: 52px; */\n  object-fit: contain;\n}\n\n.df-logo-fallback {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.df-logo-text {\n  font-size: 26px;\n  font-weight: 800;\n  font-family: var(--font-codec-cold);\n}\n\n.df-logo-g {\n  color: #F2CC00;\n}\n\n.df-logo-lammify {\n  color: white;\n}\n\n.df-logo-tagline {\n  font-family: var(--font-inter-medium);\n  font-size: 9px;\n  font-weight: 500;\n  letter-spacing: 1.5px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 2px 0 0 0;\n}\n\n/* Contact */\n.df-contact-col {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 32px;\n}\n\n.df-contact-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: white;\n  text-decoration: none;\n  font-family: var(--font-inter-medium);\n  font-size: 20px;\n  transition: opacity 0.2s;\n}\n\n.df-contact-link:hover {\n  opacity: 0.75;\n  color: white;\n}\n\n.df-apps-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.df-store-btn {\n  display: inline-block;\n  transition: transform 0.2s, opacity 0.2s;\n}\n\n.df-store-btn:hover {\n  transform: translateY(-1px);\n  opacity: 0.9;\n}\n\n.df-store-btn img {\n  /* height: 44px; */\n  object-fit: contain;\n  display: block;\n}\n\n/* Divider */\n.df-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n  margin: 32px 0 20px 0;\n}\n\n/* Bottom Row */\n.df-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.df-copyright {\n  font-family: var(--font-inter-regular);\n  font-size: 16px;\n  color: #D5D4D4;\n}\n\n.df-links {\n  display: flex;\n  gap: 32px;\n}\n\n.df-link {\n  font-family: var(--font-inter-regular);\n  font-size: 16px;\n  color: #D5D4D4;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.df-link:hover {\n  color: white;\n}\n\n/* Responsive – Footer */\n@media (max-width: 991px) {\n  .df-footer {\n    padding: 0;\n  }\n\n  .df-top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 28px;\n  }\n\n  .df-apps-col {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .df-bottom {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media (max-width: 575px) {\n  .df-footer {\n    padding: 0;\n  }\n\n  .df-store-btn {\n    min-width: 150px;\n  }\n\n  .df-links {\n    gap: 20px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1359px) {\n  .demo-content-container {\n    max-width: 1158px;\n  }\n\n  .clothing-selection {\n    top: 48%;\n    right: -63px;\n  }\n\n  .mf-title,\n  .tf-section-title {\n    font-size: 36px;\n  }\n\n  .mf-inner {\n    gap: 0px;\n    padding-left: 50px;\n    padding-right: 50px;\n  }\n\n  .mf-format-card {\n    width: 132px;\n  }\n\n  .tf-section-subtitle {\n    font-size: 19px;\n  }\n\n  .new-demo-image-cards {\n    width: 100%;\n  }\n\n  .new-demo-description {\n    padding: 0 0px 0 0;\n    font-size: 19px;\n  }\n\n  .new-demo-showcase-btn {\n    padding: 2px 40px 0 40px;\n    height: 42px;\n    font-size: 16px;\n  }\n\n  .new-demo-showcase-btn {\n    font-size: 16px;\n  }\n\n  .new-demo-heading {\n    font-size: 43px;\n  }\n}\n\n@media (min-width: 1360px) and (max-width: 1400px) {\n  .demo-content-container {\n    max-width: 1360px;\n  }\n\n  .new-demo-description {\n    padding: 0 75px 0 0;\n    font-size: 18px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
